export default __webpack_public_path__ + "static/Luxottica-04d2120c53fb5858dff72cb23906e6f4.png";